var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCommentResolved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn-comment-resolved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.51375,0 20,4.48625 20,10 C20,15.51375 15.51375,20 10,20 C4.48625,20 0,15.51375 0,10 C0,4.48625 4.48625,0 10,0 Z M14.16125,7.029375 C13.901875,6.801875 13.5075,6.8275 13.279375,7.088125 L13.279375,7.088125 L9.344375,11.585625 L7.316875,9.558125 C7.0725,9.31375 6.6775,9.31375 6.433125,9.558125 C6.18875,9.8025 6.18875,10.1975 6.433125,10.441875 L6.433125,10.441875 L8.933125,12.941875 C9.050625,13.059375 9.209375,13.125 9.375,13.125 C9.381875,13.125 9.38875,13.125 9.39625,13.124375 C9.569375,13.11875 9.731875,13.041875 9.845625,12.91125 L9.845625,12.91125 L14.220625,7.91125 C14.4475,7.65125 14.42125,7.256875 14.16125,7.029375 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-comment-resolved",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#15CD93",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCommentResolved);
export default __webpack_public_path__ + "static/media/icn-comment-resolved.8cfdb842e470e99a2916d57c7ae66902.svg";
export { ForwardRef as ReactComponent };